import {
    LOGIN_REQUEST,
    LOGIN_FAIL,
    LOGIN_SUCCESS,
    REGISTER_USER_REQUEST,
    REGISTER_USER_SUCCESS,
    REGISTER_USER_FAIL,
    LOAD_USER_REQUEST,
    LOAD_USER_SUCCESS,
    LOAD_USER_FAIL,
    LOGOUT_SUCCESS,
    LOGOUT_FAIL,
    CLEAR_ERRORS,
   
  } from "../constants/userConstants";
  
  export const userReducer = (state = { user: '',userProfile:{} }, action) => {
    switch (action.type) {
      case LOGIN_REQUEST:
      case REGISTER_USER_REQUEST:
  
        return {
          loading: true,
          isAuthenticated: false,
  
        };
      case LOAD_USER_REQUEST:
               return {
                  ...state,
          loading: true,
          isAuthenticated: true,
  
        };
      case LOAD_USER_SUCCESS:
       
        return {
          ...state,
          loading: false,
          isAuthenticated: true,
          userProfile: action.payload,
         
        };
      case LOGIN_SUCCESS:
      case REGISTER_USER_SUCCESS:
  
        return {
          ...state,
          loading: false,
          isAuthenticated: true,
          user: action.payload,
         
        };
      case LOGOUT_SUCCESS:
        return {
          loading: false,
          users: null,
          isAuthenticated: false,
  
        };
      case LOGIN_FAIL:
      case REGISTER_USER_FAIL:
      
        return {
          ...state,
          loading: false,
          isAuthenticated: false,
          users: null, 
          error: action.payload,
        };
      case LOAD_USER_FAIL:
        return {
          ...state,
          loading: false,
          isAuthenticated: false,
          userProfile: null, 
          error: action.payload,
        };
      case LOGOUT_FAIL:
        return {
          ...state,
          loading: false,
          error: action.payload,
          user:null
        };
  
      case CLEAR_ERRORS:
        return {
          ...state,
          error: null,
        };
  
      default:
        return state;
    }
  };